import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Response } from '@angular/http';
import { PasswordService } from '../../api/resources/password.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AgencyLocationService } from '../../api/resources/agency-location.service';
import { SessionService } from '../../api/session.service';
import { Modal } from 'ngx-modal';

@Component({
  selector: 'login-form',
  providers: [ PasswordService, AgencyLocationService, SessionService ],
  styleUrls: ['./login-form.component.less'],
  templateUrl: './login-form.component.html'
})
export class LoginFormComponent implements OnInit {
  public email: string;
  public password: string;
  public app_updated: boolean = false;
  public api_error: boolean = false;
  public loginError: boolean = false;
  public permissionError: boolean = false;
  public shakeLogo: boolean = false;

  @ViewChild(Modal) logoutModal: Modal

  constructor(private pwService: PasswordService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private agencyLocation: AgencyLocationService,
              private session: SessionService) { }

  ngOnInit() {
    if (window['FS']) {
      window['FS'].clearUserCookie();
    }
    // Check if logout occurred because session expired and show message
    this.app_updated = this.activatedRoute.snapshot.queryParams['app_updated'];
    this.api_error = this.activatedRoute.snapshot.queryParams['api_error'];
    if(this.app_updated || this.api_error) {
      this.logoutModal.open();
    }
  }

  login() {
    this.shakeLogo = false;
    return this.pwService.getToken(this.email, this.password)
      .subscribe(res => {
        const json = res;
        let user: any = JSON.stringify(json);

        localStorage.setItem('user', user);

        if (user.email) {
          user = JSON.parse(user);

          if (window['FS']) {
            window['FS'].identify(user._id, {
              email: user.email,
              agency_id: user.agency_id
            });
          } else {
            throw new Error('Full story not set but should be.');
          }

          if (window['Intercom']) {
            window['Intercom']("boot", {
              app_id: "zin6d58r",
              email: user.email,
              user_id: user._id,
              custom_launcher_selector: '#intercom'
            });
          } else {
            throw new Error('Intercom not set but should be.');
          }
        }

        // check if user has permission to use app
        if (this.session.app_permissions.survey) {
          this.router.navigate(['/l/location-list']);
        } else {
          this.shakeLogo = true;
          this.permissionError = true;
        }
      }, (err: any) => {
        console.log(err);
        if (this.loginError) {
          this.shakeLogo = true;
        } else {
          this.loginError = true;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login-form/login-form.component.ts